import {useQuery} from '@tanstack/react-query'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {useCommerceApi, useAccessToken} from '@salesforce/commerce-sdk-react'

const useProduct = (parameters, options = {}) => {
    const api = useCommerceApi()
    const {getTokenWhenReady} = useAccessToken()

    const getProduct = async (productId) => {
        if (!productId) return null // Early return if no productId

        try {
            const token = await getTokenWhenReady()

            const product = await api.shopperProducts.getProduct({
                parameters: parameters,
                headers: {Authorization: `Bearer ${token}`}
            })

            return {product}
        } catch (error) {
            logger.error('Error fetching Product', {
                namespace: 'useProduct.getProduct',
                additionalProperties: {error}
            })
            throw error
        }
    }

    return useQuery({
        queryKey: ['use-product', parameters?.id],
        queryFn: () => getProduct(parameters?.id),
        keepPreviousData: true,
        enabled: options?.enabled
    })
}

export default useProduct
